import React, {FC, useMemo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ButtonNew} from 'components/ButtonNew';
import {useGetCartQuery} from 'modules/cart/services';
import {useGrowingDiscountGtag} from 'modules/product-card/analytics/gtag/hooks/useGrowingDiscountGtag';

interface IProps {
    isMiniCart?: boolean;
}

const CartBanner: FC<IProps> = ({isMiniCart = true}) => {
    const {data: cartData} = useGetCartQuery({mini: true});

    const {handleMiniCartAllProductsClick, handleAddToCartAllProductsClick} = useGrowingDiscountGtag();

    const banner = useMemo(() => {
        return cartData?.banners;
    }, [cartData]);

    if (!banner) {
        return null;
    }

    return (
        <div className={style.banner}>
            <Typography variant={'label-14-r'} color={'primary100'}>
                {banner.title}
            </Typography>
            <ButtonNew
                target={'_blank'}
                href={banner.link}
                variant={'small'}
                theme={'red'}
                onClick={isMiniCart ? handleMiniCartAllProductsClick : handleAddToCartAllProductsClick}
            >
                Все товары акции
            </ButtonNew>
        </div>
    );
};

export default CartBanner;
